"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Div_1 = __importDefault(require("../Div"));
var Text_1 = __importDefault(require("../Text/Text"));
var ScaleNumberSok = function (_a) {
    var scaleNumberContainerStyles = _a.scaleNumberContainerStyles, scaleNumberStyles = _a.scaleNumberStyles, scaleNumberLabelStyles = _a.scaleNumberLabelStyles, scaleNumber = _a.scaleNumber, label = _a.label;
    var t = (0, react_i18next_1.useTranslation)().t;
    var scaleNumberLabel = t("product.scaleNumber", { defaultValue: label || '' }).toUpperCase();
    return (react_1.default.createElement(react_1.Fragment, null, scaleNumber && (react_1.default.createElement(Div_1.default, { id: 'scale-number', styles: scaleNumberContainerStyles },
        react_1.default.createElement(Text_1.default, { id: 'scale-number-text', styles: scaleNumberStyles, value: "".concat(scaleNumber) }),
        react_1.default.createElement("div", { style: scaleNumberLabelStyles }, scaleNumberLabel)))));
};
exports.default = ScaleNumberSok;
//# sourceMappingURL=ScaleNumberSok.js.map